import styled from "styled-components";
import { Modal } from "ui/Modal";
import UserForm from "./_UserForm";
import { GetVerificationMethod, useCreateUser } from "mutations/createUser";
import { useState } from "react";
import UserOtpModal from "./UserOtpModal";
import ModalDialog from "react-bootstrap/ModalDialog";
import Draggable from "react-draggable";

const StyledModal = styled.div`
  .modal-header {
    padding: 1rem 1rem;
    border-bottom: 1px solid #707070;
    margin: 10px;
    h1 {
      font-family: Montserrat Alternates-Bold;
      text-align: left;
      font-size: 18px;
      line-height: 22px;
      color: #ffffff;
    }
  }
`;
const DraggableModalDialog = props => {
  return (
    <Draggable handle='.draggable-modal'bounds={{ top: - window.innerHeight + 300, left: - window.innerHeight , right: window.innerWidth - 400, bottom: window.innerHeight - 300 }}
>
      <ModalDialog {...props} />
    </Draggable>
  );
};

export default function AddUserModal({
  show,
  user,
  onHide,
  refetch,
  userRolesData,
}) {
  const [errorMessage, setErrorMessage] = useState("");
  const userAdd = useCreateUser();
  const [isOtpModalOpen,setIsOtpModalOpen] = useState(false)
  const [customerSubmitDetails,setCustomerSubmitDetails] = useState({})
  const verificationMethod = GetVerificationMethod()
  
  const onSuccess = (values) => {
    if(!verificationMethod.data.data.bysms){
    let serverUser = {
      givenName: values.firstName,
      familyName: values.lastName,
      phoneNumber: values.mobile,
      email: values.email,
      role: values.access,
      status: values.status,
      permissions: values.permissions,
      isMfaEnabled: false,
      method: "email"
      // business: values.business?.map((department) =>{return(parseInt(department))}),
    };
    userAdd
      .mutateAsync(serverUser)
      .then(() => {
        refetch();
        onHide();
        setErrorMessage(null);
      })
      .catch(function (error) {
        if (error.response) {
          setErrorMessage(error.response.data.message);
        }
      });
    }else{
      setCustomerSubmitDetails({
        givenName: values.firstName,
        familyName: values.lastName,
        phoneNumber: values.mobile,
        email: values.email,
        role: values.access,
        status: values.status,
        permissions: values.permissions,
        isMfaEnabled: false,
        // business: values.business?.map((department) =>{return(parseInt(department))}),
      })
      setIsOtpModalOpen(true)
    }
  }

  const onCloseOtpModal = ()=>{

    setIsOtpModalOpen(false)
    onHide();
  }

  return (
    <Modal show={show} size="lg" centered onHide={onHide} dialogAs={DraggableModalDialog}>
     <StyledModal>
     <div className={'draggable-modal'}>
        <Modal.Header closeButton>
          <h1>Add User</h1>
        </Modal.Header>
        </div>
        <Modal.Body>
          <UserForm
            onSuccess={onSuccess}
            errorMessage={errorMessage}
            userRolesData={userRolesData}
          />
          {isOtpModalOpen &&(
                <UserOtpModal open={isOtpModalOpen} close={()=> onCloseOtpModal()} customerDetails={customerSubmitDetails} /> 
              )} 
        </Modal.Body>
      </StyledModal>
     
    </Modal>
  );
}
